<app-template [disablebreadcrumb]="true" [fullLayout]="false" [footerVisible]="true"
              [useCard]="true">
  <div class="app-profile">
    <h2 class="title">Meu Perfil</h2>
    <form class="p-grid ui-fluid p-col-12 col-md-6" [formGroup]="userForm" (submit)="save()"
          *ngIf="userForm">
      <div class="p-col-12 form-group stacked">
        <label for="nome">Nome*</label>
        <input id="nome" pInputText formControlName="name" type="text">
        <app-input-message [form]="userForm" field="name"></app-input-message>
      </div>
      <div class="p-col-12 p-md-8 form-group stacked">
        <label for="contactEmail">E-mail de contato*</label>
        <p-dropdown [styleClass]="'d-flex'"  id="contactEmail" [options]="optionsContactEmail"
                    formControlName="contactEmail"></p-dropdown>
        <app-input-message [form]="userForm" field="contactEmail"></app-input-message>
      </div>
      <div class="p-col-12 col-md-4 form-group stacked">
        <label for="telephone">Telefone</label>
        <p-inputMask [styleClass]="'d-flex'"   mask="(99) 99999-9999" formControlName="telephone"></p-inputMask>
        <app-input-message [form]="userForm" field="telephone"></app-input-message>
      </div>
      <div class="p-col-12 p-md-6 form-group stacked">
        <label for="locality">{{localityType}}</label>
        <p-dropdown [styleClass]="'d-flex'" id="locality" [options]="optionsLocality" formControlName="localityId"></p-dropdown>
        <app-input-message  [form]="userForm" field="localityId"></app-input-message>
      </div>
      <div class="p-col-12 form-group field-switch">
        <p-inputSwitch id="informational" formControlName="receiveInformational">
        </p-inputSwitch>
        <label for="informational">Desejo receber mensagens informativas</label>
      </div>

      <div class="actions p-col-12">
        <button class="btn-primary" type="submit" [disabled]="userForm.invalid">
          Salvar
        </button>
        <button type="button" class="btn-secondary" (click)="cancel()">
          Cancelar
        </button>
      </div>
    </form>
  </div>
</app-template>

<p-dialog [(visible)]="mergeEventData.displayMergeProfileDialog" [modal]="true"
[style]="{width:'60vw'}" showEffect="fade" [resizable]="false" [draggable]="false" [responsive]="true">
  <div class="dialog-title">
    <i class="far fa-times-circle"></i>
    <span class="title-text">
        Atenção
        Você {{mergeEventData.email}} já utilizou esse email para realizar um outro cadastro neste
        site. Você pode unificar os dois cadastros. Se o fizer, o site juntará todas as suas
        participações e passará a considerar ambos os cadastros como de uma só pessoa.
      </span>
  </div>
  <div class="dialog-content">
    <span class="question-text">Deseja unificar os seus cadastros agora?</span>
    <div class="options">
      <div class="option" (click)="wannaMergeProfile({answer: true})">
        <span>SIM</span>
      </div>
      <div class="option" (click)="wannaMergeProfile({answer: false})">
        <span>NÃO</span>
      </div>
    </div>
  </div>
</p-dialog>
